import React from 'react';
import styles from './Cans.module.css';


const Cans = ({can, fruit1, fruit2, inner, outer}) => {
    return (
        <div style={outer} className={styles.outer}>
            <div style={inner} className={styles.inner}>
                <img src={can} alt="can" className={styles.can} />
                <img src={fruit1} alt="fruit1" className={styles.fruit1} />
                <img src={fruit2} alt="fruit2" className={styles.fruit2} />
            </div>
        </div>
    )
}

export default Cans;